var render = function render(){var _vm=this,_c=_vm._self._c;return _c('print',{attrs:{"board":_vm.board,"form":_vm.form}})
}
var staticRenderFns = []

export { render, staticRenderFns }